import { React, PT, connect, withRouter } from '@gasbuddy/react';
import JSONTree from 'react-json-tree';
import { Dimmer, Loader, Segment, Dropdown, Input, Button, TextArea, Grid, Form, Table } from 'semantic-ui-react';
import { Role } from '../../roles';
import { Auth, Nav } from '../../components';
import { hasAnyGroup } from '../../../client/lib/auth';
import { fetch } from '../../../client/lib/fetch';

const theme = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#272822',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633',
};

function opts(...args) {
  return args.map(n => ({ text: n, value: n }));
}

const SERVICES = [
  'user-content-serv',
  'identity-serv',
  'loyalty-serv',
  'membership-serv',
  'vehicle-serv',
];

class BaseApiPage extends React.Component {
  state = {
    method: 'POST',
  }

  setStateField(field) {
    return (_, { value }) => {
      const stateChange = { [field]: value };
      this.setState(stateChange);
    };
  }

  callApi = (e) => {
    e.preventDefault();
    this.setState({ loading: true }, async () => {
      const { body: rawBody, service, path, method } = this.state;
      let parsedBody;
      try {
        parsedBody = JSON.parse(rawBody);
      } catch (error) {
        parsedBody = rawBody;
      }
      try {
        const { body, status } = await fetch('/system/api', {
          service,
          path,
          method,
          body: parsedBody,
        });
        this.setState({
          loading: false,
          response: {
            headers: body.headers,
            body: body.body,
            status,
          },
        });
      } catch (error) {
        this.setState({
          loading: false,
          response: {
            status: 0,
            body: error,
          },
        });
      }
    });
  }


  render() {
    const { groups } = this.props;
    const services = SERVICES
      .filter(s => hasAnyGroup(groups, Role.Superuser, `${Role.SystemApi}.${s}`));

    const { loading, response, method, path, body } = this.state;

    return (
      <Auth forRoles={[Role.Superuser, Role.SystemApi]}>
        <Nav>
          <div>
            <h1>Service APIs</h1>
            <Segment>
              <Dimmer active={loading}>
                <Loader />
              </Dimmer>

              <Form>
                <Grid columns="equal">
                  <Grid.Row>
                    <Grid.Column width={2}>
                      <Dropdown
                        selection
                        options={opts('POST', 'GET', 'PUT', 'PATCH', 'DELETE')}
                        defaultValue={method}
                        onChange={this.setStateField('method')}
                      />
                    </Grid.Column>
                    <Grid.Column width={2} textAlign="right">
                      <Dropdown
                        selection
                        options={opts(...services)}
                        placeholder="Select service..."
                        onChange={this.setStateField('service')}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <Input
                        fluid
                        onChange={this.setStateField('path')}
                        defaultValue={path}
                        placeholder="Request Path"
                        label="/"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column>
                      <TextArea
                        onChange={this.setStateField('body')}
                        defaultValue={body}
                        placeholder="Enter JSON Request Body"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column textAlign="right">
                      <Button negative onClick={this.callApi}>Call API</Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Form>
            </Segment>
            {response
              && (
              <Segment>
                <p>
                  <b>Status Code</b>
:
                  {' '}
                  {response.status}
                </p>
                <Table size="small">
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Header</Table.HeaderCell>
                      <Table.HeaderCell>Value</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {Object.entries(response.headers || []).map(([key, value]) => (
                      <Table.Row>
                        <Table.Cell>{key}</Table.Cell>
                        <Table.Cell>{value}</Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
                <JSONTree
                  invertTheme
                  shouldExpandNode={() => true}
                  data={response.body || {}}
                  theme={theme}
                />
              </Segment>
              )
            }
          </div>
        </Nav>
      </Auth>
    );
  }
}

BaseApiPage.propTypes = {
  groups: PT.arrayOf(PT.arrayOf(PT.string)).isRequired,
};

export const Api = connect(({ auth }) => ({ groups: auth.groups }))(withRouter(BaseApiPage));
